import { AwJwtResponse } from '@blk/aw-bff-typescript-models';
import { AxiosResponse, CancelToken } from 'axios';
import { awBridgeApi } from '../Base';

const GENERATE_ACCESS_TOKEN_PATH = '/v1/outbound-operation/generateAccessToken';

export const getSensitveDataOutboundAccessToken = (
  pkg: string,
  cancelToken?: CancelToken
): Promise<AxiosResponse<AwJwtResponse>> =>
  awBridgeApi.get<AwJwtResponse>(GENERATE_ACCESS_TOKEN_PATH, { params: { pkg }, cancelToken });
